define(function (require) {
    "use strict";

    var $ = require("jquery");
    var LE = require("app");
    var DataSourcesPropertiesModel = require("manager-models/DataSourcesPropertiesModel");
    var DataSourcesPropertiesCollection = {};

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        DataSourcesPropertiesCollection = Backbone.Collection.extend({
            model : DataSourcesPropertiesModel,

            getById: function(id) {
                return this.get(id);
            },
            getNumberOfEditableProperties: function() {
                return this.where({"isEditable":true}).length;
            },
            areModelsValid: function() {
                var result = true;
                _.each(this.models, function(model, index){
                    if (model.isEditable()) {
                        result = model.isValidAttr() && result;
                    }
                });
                return result;
            },
            search: function(query, multiple) {
                var model;
                var result = [];
                var pattern = new RegExp($.trim(query).replace(/ /gi, '|' ), "i");
                for (var i = 0; i < this.models.length; i++) {
                    model = this.models[i];

                    for (var attr in model.attributes) {
                        if (model.attributes.hasOwnProperty(attr) && pattern.test(model.attributes[attr])){
                            if (multiple) {
                                result.push(model);
                            }
                            else {
                                return model;
                            }
                        }
                    }
                }

                return result;
            }
        });
    });

    return DataSourcesPropertiesCollection;
});
